<template>
  <div class="aftersale-detail">
    <div style="padding-bottom:15px;">
      <el-page-header @back="goBack" content="详情页面"></el-page-header>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{ detailData.afterSaleName }}</li>
          <li class="mgb15">手机号码：{{ detailData.afterSaleMobile}}</li>
          <li class="mgb15">商品名称：{{orderDetail.orderItems && orderDetail.orderItems[0] &&
          orderDetail.orderItems[0].productSkuName}}</li>
          <li class="mgb15">子订单号：{{detailData.orderNo}}</li>
          <li>下单时间：{{ detailData.creationTime }}</li>
          <!-- <li>换货地址：姓名/手机号/详细地址</li> -->
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申请信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">售后类型：退款</li>
          <li class="mgb15">购买数量： {{ detailData.afterSaleQuantity }}</li>
          <li class="mgb15">实付金额：{{
              payTotalAccount
            }}</li>
          <!-- 退款 -->
          <li class="mgb15">
            <span class="mgr40">申请退款数量：{{ detailData.afterSaleQuantity}}</span>
            <span class="mgr40">申请退款金额：￥{{ detailData.afterSaleAmount}}</span>
            <span>退款状态：{{detailData.afterSaleType == 1 ? '退款': detailData.afterSaleType == 2 ? '退货' : '换货'}}</span>
          </li>
          <!-- 退货 -->
<!--          <li class="mgb15">-->
<!--            <span class="mgr40">申请退货数量：</span>-->
<!--            <span class="mgr40">申请退货金额：￥</span>-->
<!--            <span>退款状态：￥</span>-->
<!--          </li>-->
        </ul>
      </div>
    </el-card>
    <el-card>
      <div style="padding-top:10px;">
        <div style="margin-bottom:10px;">备注</div>
        <p></p>
        <el-input :autosize="{ minRows: 2}" style="width:500px;" v-model="remark" type="textarea"></el-input>
      </div>
      <div class="btn-box">
        <el-button @click="save" type="primary">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  OrderAfterSaleGet,
  OrderAfterSaleGetAll, OrderAfterSaleUpdate, OrderPurchaseGet
} from '../../../api/api'
export default {
  data() {
    return {
      id: null,
      detailData: {},
      remark: '',
      orderDetail: {},
      orderList: [],
      payTotalAccount:null,
    }
  },

    created() {
      if (this.$route.query.Id) {
        this.id = this.$route.query.Id;
        this.orderId = this.$route.query.orderId;
        console.log('审核退款', this.id);
        this.getDetail(this.$route.query.Id)
        this.getOrderDetail()
      } else {
        return this.$message.error('缺少售后单Id,参数缺失')
      }
    },

methods:{
  getOrderDetail() {
    OrderPurchaseGet({id: this.orderId}).then(res => {
      if (res.data.success) {
        this.orderDetail = res.data.result || {}
        this.payTotalAccount = res.data.result.payTotalAccount || null
        console.log('orderDetail',res);
        this.orderList = res.data.result.orderPurchases || []
        this.orderList.forEach(item => {
          item.supllierId = null
          item.supllierName = null
        })
      } else {
        this.$message.error(res.data.error.message);
      }
    })
  },
  save() {
    this.$confirm("确认提交保存吗?", "提示", {
      type: "warning",
      closeOnClickModal: false,
    }).then(async () => {
      let params = {};
      params.id = this.detailData.id;
      params.remark = this.remark;
      params.orderAfterSaleId = this.detailData.id;
      console.log('savbe', params)
      let res = await OrderAfterSaleUpdate(params);
      console.log('---', res);
      if (res.data.success) {
        this.$message.success(res.data.msg || '保存成功');
        await this.getDetail();
      } else {
        this.$message.error(res.data.error.message || '保存失败, 请重试');
      }
    }).catch(() => {
    });
  },
  goBack() {
    this.$router.go(-1);
  },
  async getDetail(params) {
    let res = await OrderAfterSaleGet({id: this.id})
    console.log('res', res);
    if (res.data.success) {
      this.remark = res.data.result.afterSaleRemark;
      this.detailData = res.data.result || {}
      console.log('this.detailData',this.detailData)
    } else {
      this.$message.error(res.data.error || '获取失败,请重试')
    }

  }
}
}
</script>

<style scoped>
.aftersale-detail{
  padding: 0 20px;
}
.box-card{
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: 700;
}
.mgb15{
  margin-bottom: 15px;
}
.mgr40{
  margin-right: 40px;
}
.total-box{
  margin-top: 15px;
  text-align: right;
}
.btn-box{
  /* text-align: center; */
  margin-top: 20px;
}
</style>
